import BaseInput from '../BaseInput';
import { NumericFormat } from 'react-number-format';

type Props = {
  value?: number;
  onChange?: (value: number) => void;
  placeholder?: string;
};
const NumberInput = ({ value, onChange, placeholder }: Props) => {
  return (
    <NumericFormat
      value={value}
      onValueChange={(values) => {
        onChange?.(Number(values.value));
      }}
      customInput={BaseInput}
      // allowClear={{ clearIcon: <IcClose /> }}
      placeholder={placeholder}
    />
  );
};

export default NumberInput;
